import axios from "axios";
import { Config } from "../config/config";
import { processLoadOptions } from "../helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/role`;

export const roleService = {
    getRole: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-role`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    roleList: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-role`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupRole: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-role`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createRole: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-role`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateRole: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-role`, params)
        .then((response) => {
            return response.data;
        });
    }
}
